import { SaveToCloudStatus } from './schema/SxSExtendedViewState';
import SxSStore from './schema/SxSStore';
import EventEmitter from 'owa-event-emitter';
import getInitialSxSViewState from 'owa-sxsdata/lib/utils/getInitialSxSViewState';
import { createStore } from 'satcheljs';

const initialStore: SxSStore = {
    shouldShow: false,
    viewState: getInitialSxSViewState(),
    extendedViewState: {
        previewMode: 0,
        attachmentId: null,
        selectionSource: 0,
        isCloudy: false,
        saveToCloudStatus: SaveToCloudStatus.disabled,
    },
    editState: {
        mode: 0,
        editAllowed: false,
        itemId: null,
        isDraft: false,
    },
    customPreviewState: null,
    eventManager: new EventEmitter(),
    pendingPreviewOperation: null,
    pendingNavigation: null,
    readingPaneState: null,
    composeId: null,
    customization: null,
    isInvisible: false,

    shouldUseFakeRightHandSide: false,
    isUsingFakeRightHandSide: false,
    shouldHideReadingPaneOutsideSxS: false,

    attachmentViewStateIdFromListView: null,
};

initialStore.viewState.previewPane = null;

export const getStore = createStore<SxSStore>('sxsstore', initialStore);
export default getStore();
